// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable sonarjs/cognitive-complexity */
import { call, put, all, takeEvery, select } from 'redux-saga/effects';
import { createLayoutPath, pathHasHyphenSlash, getAPIConfig } from '@tcp/core/src/utils';
import logger from '@tcp/core/src/utils/loggerInstance';
import { getNavigationData } from '@tcp/core/src/services/abstractors/common/subNavigation';
import updateModuleDataWithAspectRatio from '@tcp/core/src/utils/aspectRatio.js';
import layoutAbstractor from '../../services/abstractors/bootstrap/layout';
import GLOBAL_CONSTANTS, { MODULES_CONSTANT } from '../constants';
import { loadLayoutData, loadModulesData, setSubNavigationData } from '../actions';
import { defaultBrand, defaultChannel, defaultCountry } from '../../services/api.constants';

const getLayoutParams = (page, apiConfig, isClpPage) => {
  const layoutParams = {
    page,
    brand: apiConfig?.brandIdCMS || defaultBrand,
    channel: defaultChannel,
    country: apiConfig?.siteIdCMS || defaultCountry,
  };
  if (isClpPage || (page && pathHasHyphenSlash(page))) {
    layoutParams.pageName = createLayoutPath(page);
  }
  if (apiConfig?.regionCode) {
    layoutParams.regionCode = apiConfig.regionCode;
  }
  return layoutParams;
};

// eslint-disable-next-line complexity, max-statements
function* fetchPageLayout(action) {
  const {
    payload: { pageName: page, layoutName, isClpPage, resolve = () => null, apiConfig: config },
  } = action;

  try {
    const apiConfig = config || getAPIConfig();
    const layoutParams = getLayoutParams(page, apiConfig, isClpPage);
    const formattedPage = page && pathHasHyphenSlash(page) ? createLayoutPath(page) : page;
    const { language } = apiConfig;
    let placeHolderIdList = [];
    const isHomepage = page === 'home';
    const state = yield select();
    let layoutData = state?.Layouts[page];
    let modulesData = state?.Modules;
    if (!layoutData) {
      layoutData = yield call(layoutAbstractor.getLayoutData, layoutParams, apiConfig);
      const { errorMessage } = layoutData || {};
      if (!errorMessage) {
        const modulesDataNew = yield call(
          layoutAbstractor.getModulesFromLayout,
          layoutData,
          language,
          layoutName || formattedPage,
          apiConfig
        );
        const { isHpNewModuleLoaderDesignEnabled } = apiConfig;
        const isHpNewModuleLoader =
          isHpNewModuleLoaderDesignEnabled === 'false' ? false : isHpNewModuleLoaderDesignEnabled;
        modulesData =
          isHomepage && isHpNewModuleLoader
            ? updateModuleDataWithAspectRatio(modulesDataNew)
            : modulesDataNew;
        placeHolderIdList = Object.keys(modulesData).filter(
          (module) => modulesData[module].moduleName === MODULES_CONSTANT.placeholder
        );
        yield put(
          loadLayoutData(
            (layoutData.items[0] && layoutData.items[0].layout) || {},
            layoutName || formattedPage
          )
        );
        yield put(loadModulesData(modulesData));
      }
    }
    if (placeHolderIdList.length > 0) {
      const placeholderResult = yield all(
        placeHolderIdList.map((listItem) =>
          modulesData[listItem].moduleClassName === MODULES_CONSTANT.subNavigation
            ? call(
                getNavigationData,
                modulesData[listItem].val,
                layoutParams.brand,
                layoutParams.country,
                layoutParams.channel,
                apiConfig
              )
            : null
        )
      );
      yield all(
        placeholderResult.map((results) => put(setSubNavigationData(results.val, results.key)))
      );
    }
    resolve();
  } catch (error) {
    logger.error('Error in fetchPageLayout', {
      error,
      extraData: {
        component: 'Layout saga - fetchPageLayout',
        payloadRecieved: { pageName: page, layoutName, isClpPage },
      },
    });
    resolve();
  }
}

function* LayoutSaga() {
  yield takeEvery(GLOBAL_CONSTANTS.FETCH_PAGE_LAYOUT, fetchPageLayout);
}

export default LayoutSaga;
